export const roleConstants = {
  INTERNAL: 'INTERNAL_',
  EXTERNAL: 'EXTERNAL_',
  PRIVILEGED: 'PRIVILEGED_',
};
